/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-17 15:39:14
 * @LastEditors: linxi
 * @LastEditTime: 2021-05-21 09:26:47
 */
import { Form, Input, Button, Row, Col, Select, Space } from "antd";
import React, { useEffect } from "react";
import { UserOutlined, PlusOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { supplierParams } from "../../services/supplier";
import { NavLink, useHistory, useLocation } from "react-router-dom";
import { traceRoute } from "../../layouts/layoutSlice";
import { setCurrent } from "../wms/supplierSlice";
const { Option } = Select;

export const SupplierQuery = (props: {
  supplierSave: () => void;
  onValueChange: (queries: supplierParams) => void;
  supplierCategory: number
}) => {
  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const supplierRange = localStorage.getItem('supplierRange');

  const history = useHistory();

  return (
    <>
      <p>
        <a
          onClick={() => {
            props.supplierSave();
          }}
        >
          <PlusOutlined />
          新增
        </a>
      </p>
      <Form
        form={form}
        name="control-hooks"
        onFinish={(vs) => {
          dispatch(setCurrent(1));
          props.onValueChange({ ...vs });
        }}
      >
        <Space>
          <Form.Item name="name" noStyle>
            <Input
              placeholder={"请输入" + (props.supplierCategory ? '生产厂商' : '供应商') + "名称或拼音首字母"}
              allowClear
              prefix={<UserOutlined />}
              onInput={() => {
                form.submit();
              }}
            />
          </Form.Item>
          <Form.Item name="flag" initialValue={supplierRange && supplierRange == "0" ? 0 : 1} noStyle>
            <Select
              placeholder="查询范围"
              // suffixIcon={<CaretDownFilled />}
              onChange={(value) => {
                localStorage.setItem('supplierRange', value);
                form.submit();
              }}
            >
              <Option value={0}>{"仅查询本机构的" + (props.supplierCategory ? '生产厂商' : '供应商')}</Option>
              <Option value={1}>{"包含系统自带的默认" + (props.supplierCategory ? '生产厂商' : '供应商')}</Option>
            </Select>
          </Form.Item>
          <Button
            type="primary"
            onClick={() => {
              form.submit();
            }}
          >
            查询
          </Button>
        </Space>
      </Form>
    </>
  );
};
